// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"41f41384","453":"fe42a2bf","732":"00caa5c1"}[chunkId] + ".chunk.js";
};